<sh-radio-btn-group [formControl]="selectedAlertType" title="Alert Type" [options]="alertTypes"></sh-radio-btn-group>
